/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetLegalIndicatorsQuery from '../graphql/queries/GetLegalIndicatorsQuery.js';

const useGetLegalIndicatorsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetLegalIndicatorsQuery, args);

  return {
    error,
    loading,
    refetch,
    getLegalIndicators: R.omit(['__typename'], data?.getLegalIndicators_simulation_customer_grantees || {})
  };
};

export default useGetLegalIndicatorsQuery;
